/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_Covered_By_AllInputs */



/**
* | output |
* | --- |
* | "Already covered by all conversations." |
*
* @param {Meetings_Kind_Covered_By_AllInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_covered_by_all = /** @type {((inputs?: Meetings_Kind_Covered_By_AllInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_Covered_By_AllInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zit al bij alle gesprekken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déjà inclus dans toutes les conversations.")
	return /** @type {LocalizedString} */ ("Already covered by all conversations.")
});